import Container from '../../../../components/Container'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'
import { FormNotice } from '../components/Form'

const NoticeCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormNotice typeForm="create" />
  </Container>
)

export default NoticeCreate
